import { createApp } from 'vue'
import ConversationSession from '../components/ConversationSession.vue'

export function mountConversation() {
  const el = document.getElementById('conversation-app')
  if (!el) return

  const app = createApp(ConversationSession, {
    maxLevelUrl: el.dataset.maxLevelUrl,
    backUrl: el.dataset.backUrl,
  })
  app.mount(el)
}
